@if (showIndexChart()) {
  <div class="index-holdings__tile" [ngClass]="{ 'mod-wallet': !isPriceListChart() }">
    <div class="index-holdings__tile_section" [ngClass]="{ 'mod-pricelist': isPriceListChart() }">
      @if (!isPriceListChart()) {
        <div class="index-holdings__item-container">
          {{ "index_wallet_holdings_header" | translate }}
        </div>
      }
      <div
        class="index-holdings__wrapper"
			[ngClass]="{
				'mod-pricelist': isPriceListChart(),
				open: getViewAll()
			}">
        <div class="index-holdings__column-left">
          @if (isPriceListChart()) {
            <div class="index-holdings__item-container mod-pricelist">
              {{ "index_current_allocations_header" | translate }}
            </div>
          }
          @if (!isPriceListChart()) {
            <div class="index-holdings__allocation-list-item mod-no-border">
              <div>{{ "index_holdings_legend_name" | translate }}</div>
              <div class="header-percent">{{ "index_holdings_legend_percent" | translate }}</div>
              <div class="header-amount">{{ "index_holdings_legend_amount" | translate }}</div>
            </div>
          }
          @for (item of getVisibleIndexAllocations(); track item) {
            <div class="index-holdings__allocation-list-item">
              <div class="index-holdings__symbol-container">
                <div
                  class="index-holdings__symbol-icon"
								[ngClass]="{
									'mod-pricelist': isPriceListChart()
								}">
                  <img
                    [src]="getTradableFromItem(item).getLogo()"
                    (error)="img.src = getTradableFromItem(item).getDefaultLogo()"
                    alt="{{ 'logo_alt_text' | translate }}"
                    #img />
                </div>
                <div class="index-holdings__symbol-wrapper">
                  <div class="index-holdings__asset-symbol">
                    {{ getTradableFromItem(item)?.getSymbol(false, true) }}
                    @if (getTradableFromItem(item).isIndexOnly()) {
                      <span>*</span>
                    }
                  </div>
                  <div class="index-holdings__asset-symbol_subtitle">
                    {{ getTradableFromItem(item)?.getName() }}
                  </div>
                </div>
              </div>
              <div
                class="index-holdings__progress-bar_container"
                [ngClass]="{ 'mod-pricelist': isPriceListChart() }">
                <div
                  class="index-holdings__progress-bar_length"
								[ngClass]="{
									'mod-pricelist': isPriceListChart()
								}">
                  <div
                    class="index-holdings__progress-bar mod-fill"
                    [style.background-color]="getMapItemByAllocation(item)?.dashColor"
                  [style.width.%]="getAllocationPercent(item)"></div>
                  <div
                    class="index-holdings__progress-bar mod-empty"
                  [style.width.%]="100 - getAllocationPercent(item)"></div>
                </div>
                <div class="index-holdings__asset-percentage">{{ getAllocationPercentDisplay(item) }}%</div>
              </div>
              @if (!isPriceListChart()) {
                <div class="index-holdings__amount">
                  <div class="index-holdings__amount_fiat">
                    {{
                    getItemBalance(item, true)
                    | fiat_precision_symbol
                    : {
                    id: getFiat()?.getId(),
                    prefix: true,
                    notPrice: true,
                    symbol: true,
                    currencies: [getFiat()]
                  }
                  }}
                </div>
                <div class="index-holdings__amount_asset">
                  {{ getItemBalance(item) | tradable_precision_symbol: { id: item?.getAssetId() } }}
                </div>
              </div>
            }
          </div>
        }
        <!-- Index only coin info -->
        @if (showIndexOnlyInfo()) {
          <div class="index-holdings__info-container">
            <div class="index-holdings__info-text">{{ "index_holdings_index_only" | translate }}</div>
            <a [href]="getIndexOnlyUrl()" [target]="'_blank'">
              <div
                class="index-holdings__info-icon bpi__icon-info pl-5"
              [bp-tooltip]="'index_holdings_price_page_tooltip' | translate"></div>
            </a>
          </div>
        }
        <!-- View all/less button -->
        @if (!isPriceListChart() && useViewAll()) {
          <div class="index-holdings__view-all-wrapper">
            <button class="index-holdings__view-all-button" (click)="onClickViewAll()">
              {{ (getViewAll() ? "index_button_view_less" : "index_button_view_all") | translate }}
            </button>
          </div>
        }
      </div>
      <div class="index-holdings__column-right" [ngClass]="{ 'mod-pricelist': isPriceListChart() }">
        @if (isPriceListChart()) {
          <div class="index-holdings__legal-information">
            <div>{{ "index_holdings_price_provider" | translate }}: {{ indexProvider }}</div>
            <div>{{ "index_holdings_price_original_currency" | translate }}: {{ indexCurrencySymbol }} </div>
            <a [href]="getLegalLinkUrl()" [target]="'_blank'">{{ "index_legal_documents_link" | translate }}</a>
          </div>
        }
        <bp-donut-chart
					[customClasses]="{
						'mod-pricelist': isPriceListChart(),
						'index-holdings': true
					}"
					[labelCustomClasses]="{
						'mod-pricelist': isPriceListChart(),
						'index-holdings': true
					}"
          [donutChartSegments]="getAllMapItemByAllocation(getIndexAllocations())"
          [centerMainText]="'' + getIndexAllocations().length"
          [centerSecondaryText]="'index_chart_assets' | translate"
          [dropShadow]="true">
        </bp-donut-chart>
      </div>
    </div>
  </div>
</div>
}
